export default __webpack_public_path__ + "meetingRoomInviteDetails2.json";